import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import MainLayout from '../layouts/MainLayout';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import MyOrders from '../pages/MyOrders';
import Clients from '../pages/Clients';
import Catalog from '../pages/Catalog';
import POS from '../pages/POS';
import SalesHistory from '../pages/SalesHistory';
import UsersManagement from '../pages/UsersManagement';
import LandingPage from '../pages/LandingPage';
import OnlineOrders from '../pages/OnlineOrders';
import Pointage from '../pages/Pointage';
import Coaches from '../pages/Coaches';
import TaekwondoKids from '../pages/TaekwondoKids';
import Forfaits from '../pages/Forfaits';
import Abonnements from '../pages/Abonnements';
import Seances from '../pages/Seances';

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* Routes publiques */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                
                {/* Page d'accès refusé */}
                <Route path="/unauthorized" element={<div className="p-8 text-center text-red-500 font-bold">Accès non autorisé</div>} />

                {/* Routes protégées encapsulées dans le Layout Admin */}
                <Route element={<ProtectedRoute />}>
                    {/* Routes Client */}
                    <Route path="/my-orders" element={<MyOrders />} />

                    {/* Routes Admin / Caissier */}
                    <Route element={<MainLayout />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/abonnements" element={<Abonnements />} />
                        <Route path="/seances" element={<Seances />} />
                        <Route path="/forfaits" element={<Forfaits />} />
                        <Route path="/taekwondo" element={<TaekwondoKids />} />
                        <Route path="/pos" element={<POS />} />
                        <Route path="/pointage" element={<Pointage />} />

                        
                        {/* Routes strictement Admin */}
                        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
                            <Route path="/catalog" element={<Catalog />} />
                            <Route path="/payments" element={<div className="p-4">Paiements (TODO)</div>} />
                            <Route path="/sales-history" element={<SalesHistory />} />
                            <Route path="/online-orders" element={<OnlineOrders />} />
                            <Route path="/users-management" element={<UsersManagement />} />
                            <Route path="/coaches" element={<Coaches />} />
                        </Route>
                    </Route>
                </Route>

                {/* Redirection par défaut */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;
